import React from 'react';

const HomeService = () => {
  return (
    <section id="home-service" className="home-service">
      <div className="container">
        <div className="service-flex">
          <div className="image-part">
            <img 
              src="/images/home_service_macro.png" 
              alt="Mécanique à domicile expertise Christophe Dépanne" 
              className="service-img"
            />
            <div className="floating-badge shadow-xl">
              <span className="badge-icon">🚚</span>
              <span className="badge-text">On se déplace !</span>
            </div>
          </div>
          
          <div className="text-part">
            <span className="subtitle">Atelier Mobile</span>
            <h2 className="title">La mécanique<br/><span>qui vient à vous 🏠</span></h2>
            <p className="description">
              Gagnez du temps. <strong>Christophe Dépanne</strong> intervient chez vous ou au travail avec un atelier mobile complet pour l'entretien et les réparations. Spécialiste du dépannage à domicile sur Lahage et toute la région toulousaine.
            </p>

            <a href="#contact" className="service-cta">
              Réserver une intervention
            </a>
          </div>
        </div>
      </div>

      <style>{`
        .home-service {
          padding: 120px 20px;
          background-color: #f0f9ff;
          color: #1e293b;
          overflow: hidden;
          position: relative;
        }

        .container {
          max-width: 1200px; 
          margin: 0 auto;
        }

        .service-flex {
          display: flex;
          align-items: center;
          gap: 80px;
          flex-direction: row-reverse;
        }

        .image-part {
          position: relative;
          flex: 1;
        }

        .service-img {
          width: 100%;
          height: auto;
          border-radius: 40px;
          box-shadow: 0 40px 80px rgba(0,0,0,0.06);
          border: 1px solid #e0f2fe;
        }

        .floating-badge {
          position: absolute;
          top: -30px;
          right: -30px;
          background: #3b82f6;
          padding: 25px;
          border-radius: 30px;
          color: white;
          display: flex;
          flex-direction: column;
          align-items: center;
          box-shadow: 0 15px 35px rgba(59, 130, 246, 0.3);
          z-index: 2;
        }

        .badge-icon { font-size: 2.5rem; margin-bottom: 8px; }
        .badge-text { font-weight: 800; text-transform: uppercase; font-size: 0.85rem; letter-spacing: 1.5px; }

        .text-part { flex: 1; }

        .subtitle {
          text-transform: uppercase;
          letter-spacing: 3px;
          color: #3b82f6;
          font-weight: 800;
          font-size: 1rem;
          margin-bottom: 25px;
          display: block;
        }

        .title {
          font-size: 3.8rem;
          line-height: 1.1;
          margin-bottom: 35px;
          font-weight: 900;
          color: #0f172a;
        }

        .title span { color: #3b82f6; }

        .description {
          font-size: 1.25rem;
          color: #475569;
          line-height: 1.7;
          margin-bottom: 50px;
          max-width: 580px;
        }

        .service-cta {
          display: inline-block;
          background: #3b82f6;
          color: #ffffff;
          padding: 22px 50px;
          border-radius: 12px;
          text-decoration: none;
          font-weight: 800;
          font-size: 1.2rem;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .service-cta:hover {
          transform: translateY(-5px) scale(1.02);
          box-shadow: 0 20px 40px rgba(59, 130, 246, 0.4);
          background: #2563eb;
        }

        @media (max-width: 1024px) {
          .service-flex { flex-direction: column; gap: 100px; padding: 0 40px; }
          .title { font-size: 3rem; }
          .image-part { max-width: 600px; margin: 0 auto; }
          .text-part { text-align: center; }
          .description { margin-left: auto; margin-right: auto; }
          .floating-badge { top: -20px; right: 0; }
        }

        @media (max-width: 480px) {
          .home-service { padding: 80px 0; }
          .title { font-size: 2.2rem; }
          .floating-badge { padding: 15px; top: -15px; right: -10px; }
          .badge-icon { font-size: 1.8rem; }
          .service-cta { padding: 18px 30px; width: 100%; text-align: center; font-size: 1rem; }
          .subtitle { font-size: 0.85rem; }
        }
      `}</style>
    </section>
  );
};

export default HomeService;
